/** Prose-style markdown for Aya Work chat (matches ask-aya-health rendering). */
export function formatAyaProse(content: string, messageId?: string): string {
  if (!content?.trim()) return '';

  let text = content
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');

  text = text.replace(/```([\s\S]*?)```/g, (_m, code) => {
    return `<pre class="aya-code-block"><code>${code.trim()}</code></pre>`;
  });

  text = text
    .replace(/^### (.*)$/gim, '<h3 class="aya-prose-h3">$1</h3>')
    .replace(/^## (.*)$/gim, '<h2 class="aya-prose-h2">$1</h2>')
    .replace(/^# (.*)$/gim, '<h1 class="aya-prose-h1">$1</h1>')
    .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
    .replace(/\*(.*?)\*/g, '<em>$1</em>')
    .replace(/`([^`]+)`/g, '<code class="aya-inline-code">$1</code>')
    .replace(
      /\[([^\]]+)\]\(([^)]+)\)/g,
      '<a href="$2" class="aya-prose-link" target="_blank" rel="noopener noreferrer">$1</a>'
    );

  if (messageId) {
    text = text.replace(/\[(\d+)\]/g, (_m, n) => {
      return `<button type="button" class="aya-cite-badge" data-source-index="${n}" data-message-id="${messageId}" aria-label="Source ${n}">${n}</button>`;
    });
  }

  text = text
    .replace(/^(\d+)\.\s+(.*)$/gim, '<li class="aya-prose-li"><span class="aya-list-num">$1.</span>$2</li>')
    .replace(/^[-*]\s+(.*)$/gim, '<li class="aya-prose-li aya-prose-li-bullet">$1</li>');

  text = text.replace(/(<li class="aya-prose-li[^"]*">[\s\S]*?<\/li>\n?)+/g, (block) => {
    return `<ul class="aya-prose-ul">${block}</ul>`;
  });

  const paragraphs = text
    .split(/\n\n+/)
    .map((p) => p.trim())
    .filter(Boolean)
    .map((p) => {
      if (p.startsWith('<h') || p.startsWith('<ul') || p.startsWith('<pre')) return p;
      return `<p class="aya-prose-p">${p.replace(/\n/g, '<br>')}</p>`;
    });

  return `<div class="aya-prose">${paragraphs.join('')}</div>`;
}
